import { QuestionCircleOutlined } from '@ant-design/icons'
import { Radio, Tooltip } from 'antd'
import classNames from 'classnames'
import { useAtom } from 'jotai'
import { MyForm } from '~/components/ui/MyForm'
import { selectSizeAtom } from './atom'
import styles from '../AiForm.module.css'
import useOptions from './useOptions'

export const PictureSizeComp = () => {
  const [selectSize, setSelectSize] = useAtom(selectSizeAtom)

  const { curSizeOptions } = useOptions()

  return (
    <MyForm.Item
      label={
        <span>
          * 画面大小{' '}
          <Tooltip
            placement="topLeft"
            arrowPointAtCenter
            title="人物类的图片推荐使用 1:1的方图，景观类的图片推荐使用其他比例的尺寸"
          >
            <QuestionCircleOutlined />
          </Tooltip>
        </span>
      }
      className={classNames(styles.borderLessFormItem, '!mb-1')}
    >
      <Radio.Group
        className={styles.customRadioGroup}
        onChange={e => {
          setSelectSize(e.target.value)
        }}
        value={selectSize}
      >
        {curSizeOptions.map(item => {
          return (
            <Radio
              value={item?.name}
              key={item?.name}
              className={styles.customRadio}
            >
              <div
                className={classNames(
                  'flex flex-col items-center justify-center cursor-pointer border-2 border-solid border-neutral-200 rounded-xl duration-75  flex-1 p-3 bg-neutral-200 w-full',
                  styles.radioBtn
                )}
              >
                <img
                  alt=""
                  src={item?.url}
                  className="w-[30px] h-[30px] block"
                />
                <div className="text-neutral-800 font-semibold mt-2 !leading-none">
                  {item?.name}
                </div>
                <div className="text-neutral-500 text-[12px] mt-1 !leading-none">
                  {item?.desc}
                </div>
              </div>
            </Radio>
          )
        })}
      </Radio.Group>
    </MyForm.Item>
  )
}
